// This is a public project key, not a private Simple Commenter API key.
const projectKey = process.env.REACT_APP_SIMPLE_COMMENTER_KEY?.trim();

if (
  projectKey &&
  !document.querySelector("script[data-simple-commenter]")
) {
  const script = document.createElement("script");
  script.src = `https://simplecommenter.com/js/comments.min.js?id=${encodeURIComponent(projectKey)}`;
  script.dataset.simpleCommenter = "true";
  script.defer = true;
  document.body.appendChild(script);
}